import React from 'react';

/**
 * ReelContainer - Fixed 9:16 aspect ratio container for block content
 * Ensures all blocks fit within a consistent "reel" frame
 * Uses CSS class for consistent sizing across the app
 */
export default function ReelContainer({ children, className = '' }) {
  return (
    <div className={`reel-container ${className}`}>
      <div className="reel-container-inner">
        {children}
      </div>
    </div>
  );
}
